import { ApiError } from '../types';

export const makeApiError = (
  code: string,
  message: string,
  status?: number,
  details?: unknown,
): ApiError => ({ code, message, status, details });

export const ERR_INVALID_CREDENTIALS = (): ApiError =>
  makeApiError('INVALID_CREDENTIALS', 'Invalid email or password', 401);

export const ERR_ACCOUNT_DISABLED = (): ApiError =>
  makeApiError('ACCOUNT_DISABLED', 'Account is disabled', 403);

export const ERR_UNAUTHORIZED = (): ApiError =>
  makeApiError('UNAUTHORIZED', 'Authentication required', 401);

export const ERR_NOT_FOUND = (resource = 'Resource'): ApiError =>
  makeApiError('NOT_FOUND', `${resource} not found`, 404);

export const ERR_VALIDATION = (message: string, details?: unknown): ApiError =>
  makeApiError('VALIDATION_ERROR', message, 422, details);

export const ERR_CONFLICT = (message: string, details?: unknown): ApiError =>
  makeApiError('CONFLICT', message, 409, details);
